// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__38noz","rootSmall":"AddTileButton_rootSmall__iWjUo"};